import moment from 'moment';
import Variable from './variable';


 


        class Assignment{
         constructor(params,o=false){
          this.collection = [];
          this.accountType = "Assignment";
            this._types = {
              "variable":Variable,
              "assignment":Assignment
            }
             this.generic = {
              name:"",
              id:"",
              platformId:"",
              customerId:"",
              loginCustomerId:false,
              description:"",
              subTitle:"",
              accountType:"Assignment"
            }
          if (o){
          this.id = o.id;
           this.setParameters(o);
              if (params.accounts["Variable"] && Object.keys(params.accounts["Variable"]).length > 0){
                var _vid;
                Object.keys(params.accounts["Variable"]).map((_id) => {
                    params.permissionsTable["Variable-Assignment"].map((va) => {
                      var chk = va.objectIds[0];
                      if (_id == chk){
                      if (va.pivotObjectIds.indexOf(this.id) > -1){
                        _vid = _id;
                      }
                    }
                    })
                })
                var model = new this._types["variable"](params,params.accounts["Variable"][_vid]);
                this.setModelParameters(model);
              }

            for (var t of  Object.keys(this._types)){
             if (params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
               for (var pt of params.permissionsTable[this.accountType+"-"+t.charAt(0).toUpperCase()+t.slice(1)]){
                 if (pt.objectIds.indexOf(this.id) > -1){
                   for (var oid of pt.pivotObjectIds){
                     if ((params.accounts[pt.pivotAccountId] && params.accounts[pt.pivotAccountId][oid]) && (!this.filter || (this.filter && this.filter[pt.pivotAccountId] && this.filter[pt.pivotAccountId].indexOf(oid) > -1))) {
                        params.accounts[pt.pivotAccountId][oid].filter = this.filter;
                       params.accounts[pt.pivotAccountId][oid].truncate = (this.truncate) ? this.truncate : false;
                     var model = new this._types[t](params,params.accounts[pt.pivotAccountId][oid]);
                     this.setModelParameters(model);
                     }
                   }
                 }
             }
           }
           }
          }else{
            for (var ok of Object.keys(params.accounts["Assignment"])){
              var ac = params.accounts.Assignment[ok];
              this.collection.push(new Assignment(params,ac));
            }
            return this.collection;
          }
           
   }



             setParameters(params){
               for (var prop in params){
                   if (params.hasOwnProperty(prop)){
                       var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
                       if (this[method]){
                         this[method](params[prop]);
                       }
                       
                   }
               }

           }



           setValue(val){
            this.parentValue = val;
           }
         setOriginAccountId(id){
          this.originAccountId = id;
          this.generic.originAccountId = id;
        }
        setOriginId(id){
          this.originId = id;
          this.generic.originId = id;
        }
           
           
         setTruncate(obj){
          if (obj){
          this.truncate = obj;
          this.filtered = (obj && obj[this.accountType] && (obj[this.accountType].indexOf(this.id) > -1)) ? false : true;
          }
        }
           
       
         
       
        setModelParameters(params){
          if (params.accountType == "Variable") {
            if (params.parentProperty){
              this.parentProperty = params.parentProperty;
            }
          }else{
            if (params.accountType == "Assignment"){
              if (params.parentProperty){
                this.variables = (this.variables) ? this.variables : [];
                var vo = {value:params.parentValue,label:params.parentProperty,variables:(params.variables) ? params.variables : []};
  this.variables.push(vo);
              }
          }else{
          this[params.accountType] = (this[params.accountType]) ? this[params.accountType] : [];
           this[params.accountType].push(params);
          }
          }
       }
     }
export default Assignment;
        